import { registerAs } from '@nestjs/config';

export default registerAs('config', () => ({
  port: process.env.PORT ? parseInt(process.env.PORT, 10) : 3000,
  baseUrl: process.env.BASE_URL || 'http://127.0.0.1:3000',
  jwt: {
    secret: process.env.JWT_SECRET || '',
    expirationTime: process.env.JWT_EXPIRATION_TIME || '7d',
  },
  bcrypt: {
    saltRounds: process.env.BCRYPT_SALT_ROUNDS
      ? parseInt(process.env.BCRYPT_SALT_ROUNDS, 10)
      : 10,
  },
  crypto: {
    secret: process.env.AES_SECRET || '',
    iv: process.env.AES_IV || '',
  },
  database: {
    url: process.env.DATABASE_CONNECTION_STRING || '',
  },
  verification: {
    mode: process.env.VERIFICATION_MODE || 'email',
    codeLength: process.env.VERIFICATION_CODE_LENGTH
      ? parseInt(process.env.VERIFICATION_CODE_LENGTH, 10)
      : 4,
  },
  storage: {
    mode: process.env.STORAGE_MODE || 'local',
    dir: process.env.STORAGE_DIR || 'public/uploads',
    path: process.env.STORAGE_PATH || 'public/uploads',
  },
}));
